import { Tag, TagColor } from '@factorialco/deprecated-design-system'
import {
  GoalsValueObjectsMetricProgressAssessmentProgressStatusEnum,
  PerformanceGoalsMetricAssessmentStatusTagFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const visibleStatus: GoalsValueObjectsMetricProgressAssessmentProgressStatusEnum[] = [
  'achieved',
  'not_achieved',
  'over_achieved',
]

export const MetricAssessmentStatusTag: React.FC<{
  metric: PerformanceGoalsMetricAssessmentStatusTagFragment
}> = ({ metric }) => {
  const tagValues: Record<
    GoalsValueObjectsMetricProgressAssessmentProgressStatusEnum,
    { color: TagColor; label: string } | null
  > = {
    at_risk: {
      color: TagColor.tangerine,
      label: i18n.t('performance_goals.metric_assessment_status_tag.needs_attention'),
    },
    highly_at_risk: {
      color: TagColor.tangerine,
      label: i18n.t('performance_goals.metric_assessment_status_tag.needs_attention'),
    },
    not_achieved: {
      color: TagColor.grey,
      label: i18n.t('performance_goals.metric_assessment_status_tag.not_achieved'),
    },
    over_achieved: {
      color: TagColor.correct,
      label: i18n.t('performance_goals.metric_assessment_status_tag.over_achieved'),
    },
    achieved: {
      color: TagColor.correct,
      label: i18n.t('performance_goals.metric_assessment_status_tag.achieved'),
    },
    not_started: null,
    on_track: null,
    unknown: null,
  }

  const tagValue = tagValues[metric.progressAssessmentStatus]
  if (!tagValue) return null

  const status = metric.progressAssessmentStatus

  if (!visibleStatus.includes(status)) return null

  return (
    <Tag type={tagValue.color} ellipsis={false} inline>
      {tagValue.label}
    </Tag>
  )
}
